import cx from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";

const hasParent = (element, className) => {
  if (!element.parentNode) {
    return false;
  }
  if (element.classList.contains(className)) {
    return true;
  }

  return hasParent(element.parentNode, className);
};

export const Tooltip = ({
  className,
  style,
  position,
  isClickable,
  message,
  children,
}) => {
  const [isActive, setIsActive] = useState(false);

  const clickHandler = (e) => {
    if (hasParent(e.target, "tooltip__inner")) {
      return;
    }
    setIsActive(!isActive);
  };

  return (
    <span
      className={cx(
        `tooltip tooltip--${position}`,
        { "tooltip--clickable": isClickable },
        { "tooltip--active": isClickable && isActive },
        className
      )}
      onClick={isClickable ? clickHandler : null}
      style={style}
    >
      {children}

      <div className="tooltip__inner">{message}</div>
    </span>
  );
};

Tooltip.defaultProps = {
  isClickable: false,
  position: "right",
  className: null,
  children: null,
  style: null,
};

Tooltip.propTypes = {
  position: PropTypes.oneOf([
    "top",
    "right",
    "bottom",
    "left",
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
  ]),
  className: PropTypes.oneOfType([PropTypes.string, () => null]),
  style: PropTypes.oneOfType([PropTypes.object, () => null]),
  children: PropTypes.oneOfType([PropTypes.element, () => null]),
  message: PropTypes.element.isRequired,
  isClickable: PropTypes.bool,
};
